import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import TermsGateModal from "@/components/TermsGateModal";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="min-h-screen bg-ink" />;
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    if (!user.terms_ok) return <TermsGateModal />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
}
